import {useEffect, useState} from 'react';
import DataTable from '../../../../../shared/components/table';
import useTableV2 from '../../../../../shared/hooks/useTableV2';
import TableColumns from './columns';
import {useGetCountryRegions} from '../../hooks/useGetCountryRegions';
import {regionsTableLoading} from '../../redux/country-selectors';
import {useSelector, useDispatch} from 'react-redux';
import {IRegionListData} from '../../../../../shared/services/configuration/countries/dtos/region-list';
import {useParams} from 'react-router-dom';
import RegionModal from './create-edit-modal';
import {Row, Col} from 'antd';
import ButtonComponent from '../../../../../shared/components/button';
import {FaPlus} from 'react-icons/fa';
import {useIntl} from 'react-intl';
import {openRegionModal} from '../../redux/countrySlice';
import {
  INDEX_PAGE_SIZE_DEFAULT,
  INDEX_PAGE_SIZE_OPTIONS,
} from 'src/shared/constants/AppConst';
import DistrictsModal from './districts';

const Regions = () => {
  const {id} = useParams();
  const [pagination, setPagination] = useState({
    Page: 1,
    PageSize: INDEX_PAGE_SIZE_DEFAULT,
  });
  const [pageSizeOptions] = useState<string[]>(INDEX_PAGE_SIZE_OPTIONS);
  const {mutate, data, isLoading} = useGetCountryRegions({
    countryId: id ?? '',
    Page: pagination.Page,
    PageSize: pagination.PageSize,
  });
  const tableLoading = useSelector(regionsTableLoading);
  const {messages} = useIntl();
  const dispatch = useDispatch();
  const {showTotal, ...tableV2} = useTableV2();
  const [openDistrictsModal, setOpenDistrictsModal] = useState(false);
  const [regionIdForDistricts, setRegionIdForDistricts] = useState('');

  useEffect(() => {
    mutate();
  }, [tableLoading, pagination]);

  const tablePagination = {
    total: data?.Total ?? 0,
    pageSizeOptions: pageSizeOptions,
    pageSize: pagination.PageSize,
    showSizeChanger: true,
    showTotal,
    current: pagination.Page,
    onShowSizeChange: async (current: any, PageSize: any) => {
      setPagination({PageSize: PageSize, Page: current});
    },
    onChange: async (page: any, pageSize: any) => {
      setPagination({PageSize: pageSize, Page: page});
    },
  };

  const openDistrictsListModal = (regionId: string) => {
    setOpenDistrictsModal(true);
    setRegionIdForDistricts(regionId);
  };

  return (
    <>
      <Row gutter={[30, 30]}>
        <Col span={24}>
          <ButtonComponent
            icon={<FaPlus className='add-button-icon' />}
            onClickAction={() => dispatch(openRegionModal())}
            type='primary'
            text={messages['countries.region.add'].toString()}
            size='small'
            className='add-button'
          />
        </Col>
        <Col span={24}>
          <DataTable
            columns={TableColumns(openDistrictsListModal)}
            dataSource={data?.Data}
            pagination={tablePagination}
            rowKey={(record: IRegionListData) => record?.Id?.toString()}
            loading={isLoading}
            border
            tableProps={tableV2}
          />
        </Col>
      </Row>
      <DistrictsModal
        visible={openDistrictsModal}
        regionId={regionIdForDistricts}
        onCancel={() => {
          setOpenDistrictsModal(false);
        }}
        onFinish={() => {
          setOpenDistrictsModal(false);
        }}
      />
      <RegionModal />
    </>
  );
};

export default Regions;
